import { AfterViewInit, ChangeDetectorRef, Component, HostBinding, inject, input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { element } from 'protractor';

import { environment } from '../../../environments/environment';
import { AppService } from '../../app.service';
import { CoreService } from '../../core/core.service';
import { EnvironmentService } from '../../core/environment.service';
import { DashboardService } from '../../mwsp/shared/services/dashboard.service';
import { LayoutService } from '../layout.service';

@Component({
    selector: 'oc-sidenav',
    templateUrl: './oc-sidenav.component.html',
    styles: [':host { display: block; }'],
    standalone: false,
})
export class OcSidenavComponent implements OnInit, AfterViewInit {
    private router = inject(Router);
    private route = inject(ActivatedRoute);
    private readonly dashboardService = inject(DashboardService);
    private layoutService = inject(LayoutService);
    coreService = inject(CoreService);
    environmentService = inject(EnvironmentService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    @HostBinding('class.sidenav') private hostClassVertical = false;
    @HostBinding('class.sidenav-horizontal') private hostClassHorizontal = false;
    @HostBinding('class.flex-grow-0') private hostClassFlex = false;

    public readonly orientation = input('vertical');

    public sidenav1Collapsed = false;
    public env = environment;

    public constructor() {
        // Set host classes
        this.hostClassVertical = this.orientation() !== 'horizontal';
        this.hostClassHorizontal = !this.hostClassVertical;
        this.hostClassFlex = this.hostClassHorizontal;
    }

    public ngOnInit() {
        this.route.url.subscribe((url) => {
            // console.log(url[0].path);
            this.changeDetectorRef.detectChanges();
        });
    }

    public ngAfterViewInit() {
        // Safari bugfix
        this.layoutService._redrawLayoutSidenav();
    }

    /*
       public getClasses() {
        let bg = this.appService.layoutSidenavBg;

        if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
            bg = bg.replace(' sidenav-dark', '').replace(' sidenav-light', '').replace('-darker', '').replace('-dark', '');
        }

        return `${this.orientation === 'horizontal' ? 'container-p-x ' : ''} bg-${bg}`;
    }
     */

    public isActive(url) {
        return this.router.isActive(url, true);
    }

    public isMenuActive(url) {
        return this.router.isActive(url, false);
    }

    public isMenuOpen(url) {
        return this.router.isActive(url, false) && this.orientation() !== 'horizontal';
    }

    public toggleSidenav() {
        this.layoutService.toggleCollapsed();
    }
    protected navigateTo(path: string) {
        this.reset();
        this.router.navigate([path]);
    }
    public reset() {
        this.environmentService.resetSearchValues();

        const layoutWrapper = document.querySelector('#wrapper');
        if (layoutWrapper) {
            if (window.innerWidth < 768) {
                layoutWrapper.classList.toggle('sidenav-visible');
            }
        }
    }

    openInvoiceVerification() {
        this.dashboardService.navigateToDashboard('#rechnungspruefung');
    }
}
